import React from 'react';
import { useParams } from 'react-router';
import PropTypes from 'prop-types';
import PageRenderer from '../../components/core/PageRenderer';
import { routPropType, componentsPropType } from '../../global-prop-types';

const SponsorSectionPage = (props) => (
  <PageRenderer
    urlParams={useParams()}
    {...props}
  />
);

SponsorSectionPage.propTypes = {
  title: PropTypes.string,
  route: routPropType,
  components: componentsPropType,
};

// Default props ARE the default when building a page
SponsorSectionPage.defaultProps = {
  title: 'Sponsor Profile Page Page',
  components: [
    {
      componentName: 'JMEText',
      variant: 'h1',
      text: 'Sponsor Profile Page Title'
    }
  ],
  // Rout will be extracted to the settings
  route: {
    path: '/sponsors/section',
    exact: true
  },
};

export default SponsorSectionPage;
